const config = require("./default.json"); 

export default config;